import atlas from './atlas'
import centrum from './centrum'
import volny from './volny'
import pocasi from './pocasi'

export default {
  atlas,
  centrum,
  volny,
  pocasi
}
